export default {
    checkout: {
      started: 'لنبدأ',
      extra: 'اختر إضافاتك',
      almost_there: 'أنت تقترب!',
      signin_google: 'تسجيل الدخول باستخدام Google',
      signin_chenosis: 'تسجيل الدخول باستخدام',
      or: 'أو',
      login: 'تسجيل الدخول',
      email: 'بريدك الإلكتروني',
      password: 'كلمة السر الخاصة بك',
      password_confirmation: 'تأكيد كلمة المرور الخاصة بك',
      tip_email_verification: 'التحقق من البريد الإلكتروني إلزامي لعنوان البريد الإلكتروني المُقدم.',
      welcome: 'مرحبًا بك مجددًا',
      login_as: 'أنت مسجل الدخول كـ',
      not: 'لا',
      sign_out: 'تسجيل الخروج',
      sign_up_google: 'الاشتراك باستخدام Google',
      sign_up_chenosis: 'الاشتراك باستخدام',
      sign_up: 'الاشتراك',
      first_name: 'اسمك الأول',
      last_name: 'اسمك الأخير',
      email_registered: 'عنوان البريد الإلكتروني الخاص بك مُسجل بالفعل!',
      pick_another: 'أو اختر واحدًا آخر.',
      business: 'هل أنت عمل؟',
      company: 'اسم شركتك',
      station_name: 'أخبرنا عن محطتك.',
      station: 'اسم المحطة',
      website: 'رابط الموقع الإلكتروني (اختياري)',
      choose_extras: 'اختر الإضافات (اختياري)',
      one_time: 'مرة واحدة',
      add_this: 'أضف هذا',
      disclaimer_google: '(تنويه: مطلوب حساب Google Play رسوم مرة واحدة 30 دولارًا)',
      included: 'مشمول',
      disclaimer_apple: '(تنويه: مطلوب حساب App Store رسوم سنوية 100 دولار)',
      two_month_free: 'احصل على شهرين مجاناً!',
      annually_discount: 'ادفع اشتراكك سنويًا واحصل على 12 شهرًا من الخدمة بسعر 10!',
      pay_annually: 'ادفع سنويًا',
      chose_annual_pay: 'لقد اخترت دفع اشتراك محطتك سنويًا.',
      charge_after_trial: 'سيتم محاسبتك بعد انتهاء الفترة التجريبية. إذا كنت تفضل الدفع شهريًا، يرجى النقر',
      here: 'هنا',
      no_charging: '. لا تقلق، لن يتم محاسبتك على أي شيء اليوم. يمكنك إلغاء أو ترقية/تخفيض خطة الاشتراك الخاصة بك بسهولة في أي وقت.',
      then_charge: 'ثم سيتم محاسبتك',
      trial_ends: 'تنتهي الفترة التجريبية المجانية الخاصة بك في منتصف الليل بتاريخ',
      per: 'لكل',
      few_mention: 'أشياء قليلة للإشارة إليها فقط.',
      policy: 'يمكن العثور على تفاصيل حول كيفية استخدام المعلومات التي قدمتها في شروط الخدمة وسياسة الخصوصية لدينا. يرجى الإعلام بأنك قرأت كل من الوثائق وتوافق على هذه الشروط قبل المتابعة. يجب عليك قبول هذه الشروط قبل استخدام خدمتنا.',
      confirm: 'أؤكد أنني قد قرأت ووافقت على',
      agreement: 'اتفاقية الخصوصية',
      required: 'هذا الحقل مطلوب',
      back: 'العودة',
      step: 'الخطوة',
      next: 'التالي',
      select_plan: 'الخطة المختارة',
      storage: 'التخزين',
      listeners: 'المستمعين',
      bandwidth: 'النطاق الترددي',
      users: 'المستخدمين',
      return: 'العودة إلى الأسعار والخطط',
      your_extras: 'إضافاتك',
      processing: 'جاري المعالجة',
      start_trial: 'بدء التجربة المجانية',
    },
  };
  